import React, { useState, useEffect } from "react";
import "./css/board.css";
import NobleSidebar from "./NobleSidebar";
import Loader from "./Loader";

const BoardD = () => {
  const [directorData, setDirectorData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseUrl}/${school}/items/director_message?fields=*.*`);
        const data = await response.json();

        const directorInfo = {
          directorName: data.data[0]?.director_name,
          directorMessage: data.data[0]?.director_message,
          fullUrl: data.data[0]?.director_image?.data?.full_url,
        };
        setDirectorData(directorInfo);
      } catch (error) {
        console.error("Error fetching director message:", error);
        setError("Failed to load data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [baseUrl, school]);

  if (isLoading)
  return (
    <div className="h-[90vh] w-full flex items-center justify-center bg-white">
      <Loader />
    </div>
  );
  if (error) return <p>{error}</p>;

  return (
    <>
      <div className="container-fluid p-0">
        <div className="container-fluid d-flex latest_card_box_ad pt-0">
          <div className="ourschoolboardeft px-3 text-left">
            <h4 className="kalurr mt-3" style={{ color: "black", fontWeight: "bold" }}>
              Board Of Director
            </h4>

            <div className="princd">
              <div className="photos">
                {directorData?.fullUrl && (
                  <img
                    src={directorData.fullUrl.replace("http://", "https://")}
                    alt={directorData.directorName}
                    className="director-image"
                  />
                )}
                <div className="phname">
                  Director <b>{directorData?.directorName || "N/A"}</b>
                </div>
              </div>

              {/*Director Message Box */}
              <div className="director_mess bg-white shadow-md rounded-2xl p-6 mt-6 hover:shadow-xl w-full sm:w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] mx-auto">
                <h5 className="text-2xl font-bold text-gray-800 mb-3">
                  Message from the Board of Directors
                </h5>

                <div
                  className="border border-gray-200 rounded-xl p-3 overflow-y-auto"
                  style={{
                    maxHeight: "400px",
                    width: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.7",
                    fontSize: "1.1rem",
                    boxSizing: "border-box",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#cbd5e1 transparent",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        directorData?.directorMessage ||
                        "No message available.",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* <p className="mt-4 leading-relaxed">
              <b>
                The Board of Directors is the main governing body of the
                Maharishi Dayanand School , the school administration, establishes
                strategic direction, financial resources, reviews policies, and
                responds to community needs. The school is committed to
                inculcating in all our students; strong ethical valued of
                integrity, respect and discipline as well as clarity in thought
                and decision-making ability, as a life-long process. In order to
                achieve all this, We follow a rigorous programme that is based
                upon the best educational practices,  Our state-of-the-art infrastructure, coupled
                with highly qualified and well-trained teachers, ensures that
                the students at Maharishi Dayanand School should be able to gain an enriching
                experience. Furthermore, it has been one of my quests in life to
                make high quality education available; accessible through the
                latest educational technology. The mission of the school is to
                develop responsible global citizens and leaders through academic
                excellence, We will be the foundation for a new generation of
                leaders and innovators, who will continue to pave the way for a
                better and brighter future for our world. The greatest strength
                of Maharishi Dayanand School is the high quality programmes and transparency in
                its system. We are fortunate to have a school community which
                includes talented teachers and supportive parents who work
                together to make Maharishi Dayanand School , an ideal place for our motivated
                students to learn and grow. We are always open to new ideas,
                inquiries and feedback, from all.  I welcome you to be a part of Maharishi Dayanand School
                family!
              </b>
            </p> */}
          </div>

          <div className="ourschoolright p-4">
            <NobleSidebar />
          </div>
        </div>
      </div>
    </>
  );
};

export default BoardD;
